import React, { useState } from "react";
import { Button, Form, InputGroup, Col, Row } from "react-bootstrap";
import Modal from "react-bootstrap/Modal";
// import './successModal.scss'
import { useNavigate } from "react-router-dom";
import authorizelogo from "../../assets/images/Authorize.net_logo.png"

const SubPaymentModal = (props) => {
  // const navigate = useNavigate();
  //
  return (
    <>
      <Modal
        show={props.subPaymentModal}
        size="sm"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header
          onClick={() => props.handleClose()}
          closeButton
        ></Modal.Header>
        <Modal.Body>
          <>

            <div className="add-new-card-form" style={{ marginTop: "20px" }}>

              <div className="add-new-card w-100">
          <div className="add-new-title">🔒Secure Payment</div>

                <Row className="g-3">
                  <Col md={12}>
                    <Form.Label>Card Number</Form.Label>
                    <Form.Control
                      type="text"
                      value={props.cardNumber}
                      placeholder="Enter Card Number"
                      onChange={(e) => props.handleCardNumber(e.target.value)}
                    />
                    <div className="payment-error">
                      {props.errors?.cardNumber
                        ? props.errors.cardNumber
                        : null}
                    </div>
                  </Col>
                  <Col md={4}>
                    <Form.Label>Expiry Month</Form.Label>
                    <Form.Select
                      aria-label="Default select example"
                      value={props.cardMonth}
                      onChange={(e) => props.setCardMonth(e.target.value)}
                    >
                      <option>Select Month</option>
                      <option value="01">01</option>
                      <option value="02">02</option>
                      <option value="03">03</option>
                      <option value="04">04</option>
                      <option value="05">05</option>
                      <option value="06">06</option>
                      <option value="07">07</option>
                      <option value="08">08</option>
                      <option value="09">09</option>
                      <option value="10">10</option>
                      <option value="11">11</option>
                      <option value="12">12</option>
                    </Form.Select>
                  </Col>
                  <Col md={4}>
                    <Form.Label>Expiry Year</Form.Label>
                    <Form.Control
                      type="text"
                      value={props.cardYear}
                      placeholder="Enter Expiry Year"
                      onChange={(e) => props.setCardYear(e.target.value)}
                    />
                    <div className="payment-error">
                      {props.errors?.cardYear ? props.errors.cardYear : null}
                    </div>
                  </Col>
                  <Col md={4}>
                    <Form.Label>CVV</Form.Label>
                    <Form.Control
                      type="text"
                      value={props.cvv}
                      placeholder="Enter CVV"
                      onChange={(e) => props.setCvv(e.target.value)}
                    />
                    <div className="payment-error">
                      {props.errors?.cardCvv ? props.errors.cardCvv : null}
                    </div>
                  </Col>
                </Row>
              </div>
            </div>

            <div className="w-100 d-grid pay-wrap" style={{marginTop: "25px"}}>
              <Button
                variant="outline-primary"
                onClick={() => props.handleApplyCode()}
              >
                Pay Now
              </Button>
            </div>
            <div className="secured-payment d-flex justify-content-end align-items-center" style={{marginTop: "25px"}}>
                    <span style={{ fontSize: '14px' }}>Powered By :</span>
                  </div>
            <div className="secured-payment d-flex justify-content-end align-items-center">

                  <img
                    src={authorizelogo}
                    alt="Authorize Logo"
                    style={{ width: '100px', height: 'auto' }}
                  />
                </div>
          </>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default SubPaymentModal;
